module.exports = __webpack_public_path__ + "img/senryuNightsGif1.7d4c12bd.gif";